import type { Chain } from 'viem/chains';
import { z } from 'zod';

import { addressSchema, evmTokenSchema } from '@endaoment-frontend/types';

export const environmentSchema = z.enum(['local', 'dev', 'staging', 'demo', 'production']);
export type Environment = z.infer<typeof environmentSchema>;

export type ConfigEntry = {
  environmentName: Environment;
  chains: [Chain, ...Array<Chain>];
  baseUrls: {
    app: string;
    marketing: string;
    blog: string;
    api: string;
    docs: string;
    oauth: string;
    miniApp: string;
    overview: string;
  };
  socialLoginChainId: Chain['id'];
  googleMapsApiKey: string;
  mapboxApiKey: string;
  zeroDev: {
    projectId: string;
    bundlerRpcUrl: string;
    paymasterRpcUrl: string;
  };
  privyAppId: string;
  identifiersSecret: string;
};

export type App = keyof Pick<ConfigEntry['baseUrls'], 'app' | 'blog' | 'marketing' | 'miniApp' | 'oauth'>;

export const defaultsEntrySchema = z.object({
  confirmations: z.object({
    donation: z.number(),
    wirePayout: z.number(),
    walletPayout: z.number(),
    portfolioTrade: z.number(),
    transfer: z.number(),
    setManager: z.number(),
    orgDeployment: z.number(),
    fundDeployment: z.number(),
  }),
  fees: z.object({
    fundDonationFeeBps: z.number(),
    orgDonationFeeBps: z.number(),
  }),
  network: z.object({
    defaultChainId: z.number(),
    supportedNetworkSettings: z.array(
      z.object({
        chainId: z.number(),
        baseToken: evmTokenSchema,
        nativeToken: evmTokenSchema,
        contracts: z.object({
          registry: addressSchema,
          orgFundFactory: addressSchema,
          batchOrgDeployer: addressSchema,
          transferDeployer: addressSchema,
          entityMulticall: addressSchema,
        }),
      }),
    ),
  }),
  roles: z.object({
    keeper: z.array(addressSchema),
    accountant: z.array(addressSchema),
    maintainer: z.array(addressSchema),
    reviewer: z.array(addressSchema),
  }),
  stripePublishableKey: z.string(),
});
export type DefaultsEntry = z.infer<typeof defaultsEntrySchema>;
